import React from 'react';
import { SEO } from '../components/SEO';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { CreateKitty } from '../components/CreateKitty';
import { WaysToJoin } from '../components/WaysToJoin';
import { AddExpenses } from '../components/AddExpenses';
import { WhoOwesWhom } from '../components/WhoOwesWhom';
import { MyBalance } from '../components/MyBalance';
import { SettleUp } from '../components/SettleUp';
import { RoundSpinner } from '../components/RoundSpinner';
import { HistorySection } from '../components/HistorySection';
import { UseCases } from '../components/UseCases';
import { Pricing } from '../components/Pricing';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-screen bg-white font-sans selection:bg-kitty-yellow-200 selection:text-kitty-dark" data-id="element-529" data-mp="3owvpua4ocu6s">
      <SEO title="KittyPot | Split the cost. Not the friendship." description="Track group expenses, see exactly who owes what and settle up without the awkwardness. Friends can even join from their browser, no app required. Free on Google Play." ogTitle="KittyPot | Split the cost. Not the friendship." ogDescription="Track group expenses, see who owes what and settle up without the awkwardness. Friends can join from their browser, no app required." path="/" jsonLd={{
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: 'KittyPot',
      url: 'https://www.kittypot.com',
      description: 'KittyPot is a shared expense tracker for friends, trips and housemates. Create a kitty, track who paid what, see who owes what, and settle up directly with each other. KittyPot does not hold or move money.'
    }} data-id="element-530" data-mp="30xb8m1lj0tvo" />
      <Navbar data-id="element-531" data-mp="1u9ntmjyeqzf3" />
      <main data-id="element-532" data-mp="1u8uv269lrg81">
        <HeroSection data-id="element-533" data-mp="1uafplvvx2z5w" />
        <ProblemSection data-id="element-534" data-mp="1kkqnlgkg8gf0" />
        <CreateKitty data-id="element-535" data-mp="1kkh6kihdtjlg" />
        <WaysToJoin data-id="element-536" data-mp="1kjxql7bal5a2" />
        <AddExpenses data-id="element-537" data-mp="1kmtmyr7hrlwe" />
        <WhoOwesWhom data-id="element-538" data-mp="1omc91qb1u30t" />
        <MyBalance data-id="element-539" data-mp="1omu3che5i763" />
        <SettleUp data-id="element-540" data-mp="1on3rs0jjs69o" />
        <RoundSpinner data-id="element-541" data-mp="1onnb9louj2pt" />
        <HistorySection data-id="element-542" data-mp="1ojzi4nnbcibm" />
        <UseCases data-id="element-543" data-mp="1an2qwl3a8yu7" />
        <Pricing data-id="element-544" data-mp="1ankuy3w6shco" />
        <FinalCTA data-id="element-545" data-mp="1ao44oxbonzfm" />
      </main>
      <Footer data-id="element-546" data-mp="1aow0a85a5x5w" />
    </div>;
}